import { render, staticRenderFns } from "./EarthIcon.vue?vue&type=template&id=146953fb&"
import script from "./EarthIcon.vue?vue&type=script&lang=js&"
export * from "./EarthIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports